import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Stack } from "@mui/material";
import { useColorPicker } from "../hooks/useColorPicker.js";
function Footer(props) {
  const { onCommit, onCancel, commitDisabled } = props;
  const {
    localeText,
    router: {
      route: { id }
    }
  } = useColorPicker();
  const commitText = id === "add-color-to-palette" ? localeText.footerButtonAddColor : localeText.footerButtonCommit;
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: 1, width: "100%", alignItems: "center", justifyContent: "flex-end", children: [
    /* @__PURE__ */ jsx(Button, { variant: "text", onClick: onCancel, "data-testid": "TidalColorPickerFooterCancelButton", children: localeText.footerButtonCancel }),
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "contained",
        color: "primary",
        onClick: onCommit,
        disabled: commitDisabled,
        "data-testid": "TidalColorPickerFooterCommitButton",
        children: commitText
      }
    )
  ] });
}
export {
  Footer
};
//# sourceMappingURL=Footer.js.map
